import styled from 'styled-components';

export default styled.div`
   position: relative;

   .document-upload {
      border: 1px dashed #ced4da;
      border-radius: 8px;
      padding: 16px;
      background: #fafafa;
   }

   .document-upload.has-file {
      border-color: #56c470;
      background: #f6fff8;
   }

   .document-upload.has-error {
      border-color: #dc3545;
      background: #fff5f5;
   }

   .document-upload__label {
      font-weight: 600;
      margin-bottom: 4px;
      display: block;
   }

   .document-upload__hint {
      font-size: 12px;
      color: #6c757d;
      margin-bottom: 10px;
   }

   .document-upload__status {
      font-size: 12px;
      color: #56c470;
      margin-bottom: 8px;
   }

   .document-upload__error {
      font-size: 12px;
      color: #dc3545;
      margin-top: 6px;
   }

   .document-upload input[type='file'] {
      font-size: 13px;
   }
`;
